import {
  ADD_RESIDENCE_HISTORY,
  UPDATE_RESIDENCE_HISTORY,
  REMOVE_RESIDENCE_HISTORY,
  RESET_RESIDENCE_HISTORY,
} from '../constants/actionTypes';
import { startOfMonth, endOfMonth } from '../lib/dateFormatter';
import { differenceInMonths, residenceEndDate } from '../lib/dateRanges';

const initialState = [];

function matchingEntry(payload, residence) {
  const { countryCode, stateCode, startMonth, startYear } = payload;
  const {
    countryCode: resCountry,
    stateCode: resState,
    startMonth: resMonth,
    startYear: resYear,
  } = residence;
  return (
    countryCode === resCountry &&
    stateCode === resState &&
    startMonth === resMonth &&
    startYear === resYear
  );
}

function addAddressRequiredFlag(newState) {
  return newState.map((residence, index) => {
    const nextResidence = newState[index - 1];
    const currentDate = new Date(Date.now());
    const [endYear, endMonth] = residenceEndDate(currentDate, nextResidence);

    const start = startOfMonth(new Date(residence.startYear, residence.startMonth));
    const end = endOfMonth(new Date(endYear, endMonth));
    const difference = differenceInMonths(start, end);

    let addressRequired = false;
    // If time spent between locations is equal to or more than a year,
    // address is required or if this is the first address in the list AND
    // if the list is less than 3 addresses long as we capture up to 3 addresses.
    if ((difference >= 12 || index === 0) && index < 3) {
      addressRequired = true;
    }
    return { ...residence, addressRequired };
  });
}

function sortItems(state, payload) {
  const newState = payload !== undefined ? [...state, payload] : [...state];

  newState.sort((first, second) => {
    const firstDate = startOfMonth(new Date(first.startYear, first.startMonth));
    const secondDate = startOfMonth(new Date(second.startYear, second.startMonth));
    return secondDate - firstDate;
  });

  return newState.map((item, index) => ({ ...item, index }));
}
function insertItem(state, payload) {
  const newState = sortItems(state, payload);
  return addAddressRequiredFlag(newState);
}

function removeItem(state, removeIndex) {
  return state.filter((item, index) => index !== removeIndex);
}

function removeItemWithKey(reduxState, payload) {
  const newState = reduxState.filter(item => {
    const { countryCode, stateCode } = item;
    const idString = `${countryCode}|${stateCode}`;
    return idString !== payload;
  });

  return addAddressRequiredFlag(newState);
}

function residenceHistory(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case ADD_RESIDENCE_HISTORY: {
      const existingCountryStateIndex = state.findIndex(residence =>
        matchingEntry(payload, residence),
      );

      if (existingCountryStateIndex !== -1) {
        const stateWithRemovedItem = removeItem(state, existingCountryStateIndex);
        return insertItem(stateWithRemovedItem, payload);
      }
      return insertItem(state, payload);
    }

    case UPDATE_RESIDENCE_HISTORY: {
      const { index } = payload;
      const newState = state.map((item, i) => (i === index ? payload : item));
      return addAddressRequiredFlag(sortItems(newState));
    }

    case REMOVE_RESIDENCE_HISTORY:
      return removeItemWithKey(state, payload);

    case RESET_RESIDENCE_HISTORY:
      return [];

    default:
      return state;
  }
}

export default residenceHistory;
